<template>
  <div class="preview-dialog">
    <el-dialog
      :title="$t('lcd.Devices.Task Detail')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="cont">
        <el-descriptions size="medium" :column="2" class="imgInfo" title="">
          <el-descriptions-item :label="$t('lcd.Devices.Task ID')">{{
            previewObj.taskId
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Devices.Device ID')">{{
            previewObj.screenCode
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Devices.Task Type')">
            <el-tag size="small" type="info">{{
              previewObj.taskTypeDesc
            }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Devices.Task State')">
            <el-tag
              size="small"
              type="danger"
              v-if="previewObj.taskState == '4601'"
              >{{ previewObj.taskStateDesc }}</el-tag
            >
            <el-tag size="small" v-if="previewObj.taskState == '4602'">{{
              previewObj.taskStateDesc
            }}</el-tag>
            <el-tag
              size="small"
              type="warning"
              v-if="previewObj.taskState == '4603'"
              >{{ previewObj.taskStateDesc }}</el-tag
            >
            <el-tag
              size="small"
              type="info"
              v-if="previewObj.taskState == '4604'"
              >{{ previewObj.taskStateDesc }}</el-tag
            >
            <el-tag
              size="small"
              type="success"
              v-if="previewObj.taskState == '4605'"
              >{{ previewObj.taskStateDesc }}</el-tag
            >
          </el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Devices.Update Time')">
            {{ previewObj.updateTime }}
          </el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Devices.Oprate User')">{{
            previewObj.updateUser
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Devices.Task Result')">{{
            previewObj.taskResultDesc
          }}</el-descriptions-item>
          <el-descriptions-item v-if="previewObj.err" :label="$t('lcd.Devices.Error Info')">{{
            previewObj.err
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "ConfirmDialog",
  data() {
    return {};
  },
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
    },
    previewObj: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handleClose(val) {
      this.$emit("handleClose", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.preview-dialog ::v-deep {
  color: #35b871;
  .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-dialog {
    // height: 600px;
    border-radius: 6px;
    width: 1000px;
    margin-top: 0 !important;
    margin: 0 !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }
  .cont {
    width: 100%;
    text-align: center;
    // height: 510px;
    .icon {
      display: flex;
      justify-content: center;
      color: #ff9600;
    }
    ::v-deep .el-icon-warning-outline {
      font-size: 46px;
    }
    .text {
      margin-top: 16px;
      display: inline-block;
      // color: #FF9600;
    }
  }
  .cancel,
  .confirm {
    cursor: pointer;
    width: 50%;
    position: absolute;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #e6e6e6;
    vertical-align: center;
  }
  .cancel {
    border-right: 1px solid #e6e6e6;
    left: 0;
    color: #333333;
  }
  .confirm {
    right: 0;
    color: #35b871;
  }
}
</style>